module.exports = __webpack_public_path__ + "abc916619318a17ac1650dbb4cd9368c.svg";